import React from 'react';
import HomePageImg from '../imgs/homepage.jpg';
import Landscape1 from "../imgs/landscape1.jpg";
import Landscape2 from "../imgs/landscape2.jpg"
import Tree1 from "../imgs/icetree1.jpg"
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="relative flex flex-col items-center">
      

      <div className="relative w-full flex items-center justify-center z-0">
        <div className="absolute inset-0 bg-tan bg-opacity-50"></div>
        <div className="hidden lg:block w-1/4 h-screen">
          <img
            src={Landscape1}
            alt="Flower Left"
            className="w-full h-full object-cover"
          />
        </div>

        <div
          className="w-full lg:w-1/2 h-screen relative bg-cover bg-center"
          style={{ backgroundImage: `url(${HomePageImg})` }}
        >
          <div className="absolute inset-0 bg-tan bg-opacity-50 z-10 pointer-events-none"></div>

          <div className="absolute inset-0 flex items-center justify-center text-greentext z-20 drop-shadow-sm px-4">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold drop-shadow-lg text-center">
              Embrace Your Life.
            </h1>
          </div>
        </div>
        <div className="hidden lg:block w-1/4 h-screen">
          <img
            src={Landscape2}
            alt="Flower Right"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="w-full min-h-40 bg-tanbg py-8 z-20 relative">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="md:hidden flex flex-col items-center space-y-8">
            <a
              href="https://calendly.com/seanmotiv8living"
              className="text-greentext font-semibold text-xl hover:text-greenbutton transition text-center"
            >
              Sign Up Now
            </a>
            <Link to="/contact" className="text-greentext font-semibold text-xl hover:text-greenbutton transition text-center">
              Contact Us
            </Link>
          </div>
          
          <div className="hidden md:flex justify-center items-center">
            <div className="flex-1 flex justify-center">
              <a
                href="https://calendly.com/seanmotiv8living"
                className="text-greentext font-semibold text-2xl hover:text-greenbutton transition"
              >
                Sign Up Now
              </a>
            </div>

            <div className="mx-24 h-60 border-l border-greentext"></div>

            <div className="flex-1 flex justify-center">
              <Link to="/contact" className="text-greentext font-semibold text-2xl hover:text-greenbutton transition">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-lighttan">
        <div className="md:hidden">
          <div className="relative">
            <img
              src={Tree1}
              alt="Description 1"
              className="w-full h-64 object-cover"
            />
            <div className="absolute inset-0 bg-tantext opacity-30"></div>
          </div>
        </div>
        
        <div className="hidden md:block">
          <div className="relative">
            <img
              src={Tree1}
              alt="Description 1"
              className="w-full h-64 object-cover"
            />
            <div className="absolute inset-0 bg-tantext opacity-30"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
